import { IPromo } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectCoPromos = (state: IApplicationState): IPromo[] => {
  return state.promosPage.coPromos;
};
